export default {
  header: {
    hideMenuBar: 'Hide menu bar',
    showMenuBar: 'Show menu bar'
  }
}
